import apiRequest from './api-request';
import type { TenantRoute, TenantRoutePoint, TenantRouteShape } from '../types';

export function getTenantRoutes(): Promise<TenantRoute[]> {
    return apiRequest({
        method: 'GET',
        resource: 'tenant-routes'
    });
}

export function createTenantRoute(body: {
    name: string,
    /** Omitted for circles (the API derives the points from the shape) */
    points?: TenantRoutePoint[],
    shape?: TenantRouteShape | null,
    isPublic?: boolean
}): Promise<TenantRoute> {
    return apiRequest({
        method: 'POST',
        resource: 'tenant-routes',
        body
    });
}

export function updateTenantRoute(id: number, body: {
    name?: string,
    points?: TenantRoutePoint[],
    shape?: TenantRouteShape | null,
    isPublic?: boolean
}): Promise<TenantRoute> {
    return apiRequest({
        method: 'PUT',
        resource: 'tenant-routes',
        id,
        body
    });
}

export function deleteTenantRoute(id: number): Promise<{ id: number, pausedWatchlistCount: number }> {
    return apiRequest({
        method: 'DELETE',
        resource: 'tenant-routes',
        id
    });
}
